import { render } from "./NotificationsAlert.vue?vue&type=template&id=46d79422&scoped=true&ts=true"
import script from "./NotificationsAlert.vue?vue&type=script&lang=ts"
export * from "./NotificationsAlert.vue?vue&type=script&lang=ts"

import "./NotificationsAlert.vue?vue&type=style&index=0&id=46d79422&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d79422"]])

export default __exports__